import TrackedObject from "@/models/TrackedObject";
import HasID from "@/models/HasID";
import HasLabel from "@/models/HasLabel";
import { EntityType } from "@/models/EntityType";

export interface AcceptanceConfiguration extends TrackedObject, HasID {
    id: number;
    name: string;
    linkedEntities: LinkedEntity[];
    imageId?: number;
    mandatory: boolean;
    recurring: boolean;
    requiresSignature: boolean;
    status: AcceptanceConfigurationStatus;
    checked: boolean;
    defaultExpirationMode: AcceptanceConfigurationExpirationMode;
    defaultExpirationModeValue: number;
}

export enum AcceptanceConfigurationStatus {
    // noinspection JSUnusedGlobalSymbols
    Draft = 0,
    Active = 1,
    Inactive = 2,
}

export enum AcceptanceConfigurationExpirationMode {
    None,
    NumberOfDays,
    NumbersOfYears,
    CalendarYear
}

export interface LinkedEntity {
    entityId: number;
    entityType: EntityType;
}

export class AcceptanceConfiguration extends HasLabel {
    constructor(obj?: AcceptanceConfiguration) {
        super();
        this.linkedEntities = [];
        if (obj) {
            Object.assign(this, obj);
        }
    }

    toString(): string {
        if (!this.id) return "";
        return `${this.id} - ${this.name}`;
    }
}
